import React, { useState, useEffect } from "react";
import "./productDetails.scss";
import {
  Box,
  Chip,
  Divider,
  Grid,
  MenuItem,
  Select,
  useMediaQuery,
  Stack,
  Skeleton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

// icon
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import FavoriteBorderRoundedIcon from "@mui/icons-material/FavoriteBorderRounded";

const ProductDetailsSkeleton = () => {
  const matches = useMediaQuery("(max-width:600px)");
  const imgLoading = [1, 2, 3, 4, 5];
  const sizeLoading = [1, 2, 3];

  return (
    <div className="product-details" style={{ width: "100%" }}>
      <Grid container spacing={matches ? 0 : 4}>
        <Grid
          container
          item
          className="left-side"
          spacing={2}
          lg={7}
          md={8}
          sm={6}
          xs={12}
        >
          <div
            style={{
              marginLeft: "5px",
              transition: "all 0.5s ease",
              width: "100%",
            }}
          >
            <Grid container spacing={2}>
              {imgLoading.map((item) => (
                <Grid
                  item
                  xs={6}
                  key={item}
                  className="is-web-image"
                  display={{
                    xs: "none",
                    lg: "block",
                    sm: "none",
                    md: "block",
                  }}
                >
                  <div
                    className="product-single-image"
                    style={{ width: "100%" }}
                  >
                    <Skeleton animation="wave" height={550} width="100%" />
                  </div>
                </Grid>
              ))}
            </Grid>
          </div>
          <Grid
            item
            xs={12}
            className="is-mobile-image"
            display={{ xs: "block", lg: "none", sm: "block", md: "none" }}
          >
            <Box>
              <div className="carousel">
                <div className="singleCarousel">
                  <Skeleton animation="wave" component="img" />
                </div>
              </div>
            </Box>
          </Grid>
        </Grid>
        <Grid
          container
          item
          spacing={2}
          lg={5}
          md={4}
          sm={6}
          xs={12}
          className="right-side-details"
        >
          <Grid container item>
            <Box
              component="div"
              sx={{ width: "100%", transition: "all 0.5s ease" }}
            >
              <Skeleton animation="wave" width="100%">
                <h1 className="product-name">a</h1>
              </Skeleton>
              <Skeleton animation="wave" width="100%">
                <p className="product-sub-description">a</p>
              </Skeleton>
              <div className="rating">
                <Skeleton animation="wave">
                  <p className="rating-star">0.0</p>
                </Skeleton>
                <StarRoundedIcon className="icon" />
                <Skeleton animation="wave">
                  <p className="total-rating">(00 Reviews)</p>
                </Skeleton>
              </div>
              <div className="price">
                <Skeleton animation="wave" width="100px" />
              </div>
              <div className="sizes">
                <p>Select Size</p>
                <Stack className="size-chip" direction="row" spacing={2}>
                  {sizeLoading.map((size) => (
                    <Skeleton animation="wave" key={size}>
                      <Chip variant={"filled"} className="chip" />
                    </Skeleton>
                  ))}
                </Stack>
              </div>

              <div className="colors">
                <p>Select Color</p>
                <div className="color-select-container">
                  <Skeleton animation="wave">
                    <Select value="empty" className="color-select">
                      <MenuItem value="select-color" disabled>
                        Select Color
                      </MenuItem>
                      <MenuItem value="empty">empty</MenuItem>
                    </Select>
                  </Skeleton>
                </div>
              </div>

              <LoadingButton
                className="wishlist-btn"
                disabled
                startIcon={<FavoriteBorderRoundedIcon className="icon" />}
              >
                <p>Quick Look</p>
              </LoadingButton>

              <Skeleton animation="wave">
                <div className="delivery-days">
                  Delivery within <span>7 days</span>
                </div>
              </Skeleton>

              <div className="cart-btn">
                <LoadingButton variant="contained" className="btn" disabled>
                  <p>Add To Cart</p>
                </LoadingButton>
              </div>

              <Divider className="divider" />
              <div className="product-description">
                <p className="desc-title">Description</p>
                <Skeleton
                  variant="rounded"
                  animation="wave"
                  height={200}
                  width="100%"
                >
                  <div className="html-desc" />
                </Skeleton>
              </div>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ProductDetailsSkeleton;
